import { Typography } from '@mui/material'
import { Button } from 'eezy-components'
import { Trans } from 'react-i18next'

import UploadAwaiting from '../icons/upload/upload-awaiting.svg'
import UploadComplete from '../icons/upload/upload-complete.svg'
import UploadInactive from '../icons/upload/upload-inactive.svg'

import VerifyAwaiting from '../icons/verify/verify-awaiting.svg'
import VerifyComplete from '../icons/verify/verify-complete.svg'
import VerifyInactive from '../icons/verify/verify-inactive.svg'

import ReviewAwaiting from '../icons/review/review-awaiting.svg'
import ReviewComplete from '../icons/review/review-complete.svg'
import ReviewInactive from '../icons/review/review-inactive.svg'

import * as S from './styled'

type Props = {
  title: string
  content: string
  buttonAction?: () => void
  buttonText?: string
  type: 'upload' | 'verify' | 'review'
  state: 'inactive' | 'awaiting' | 'complete'
  step: number
  disableAction?: boolean
}
const Step = ({
  title,
  step,
  content,
  buttonAction,
  buttonText,
  state,
  type,
  disableAction = false,
}: Props) => {
  const icons = {
    upload: {
      inactive: <UploadInactive />,
      awaiting: <UploadAwaiting />,
      complete: <UploadComplete />,
    },
    verify: {
      inactive: <VerifyInactive />,
      awaiting: <VerifyAwaiting />,
      complete: <VerifyComplete />,
    },
    review: {
      inactive: <ReviewInactive />,
      awaiting: <ReviewAwaiting />,
      complete: <ReviewComplete />,
    },
  }

  const renderIcon = (type: Props['type'], state: Props['state']) => {
    return icons[type][state]
  }

  return (
    <S.Container>
      <S.Header>
        <S.IconWrapper>{renderIcon(type, state)}</S.IconWrapper>
        <Typography
          variant="mediumBoldText"
          color="secondary.light"
        >{`${step}. ${title}`}</Typography>
      </S.Header>
      <S.Content>
        <Typography variant="body1">
          <Trans
            i18nKey={content}
            components={{
              url: (
                <a
                  href="https://eezycontributors.zendesk.com/hc/en-us/articles/360032985951-Content-Guidelines"
                  target="_blank"
                  rel="noreferrer"
                />
              ),
            }}
          />
        </Typography>
      </S.Content>
      {buttonAction && buttonText ? (
        <S.ActionContainer>
          <Button
            color="primary"
            onClick={buttonAction}
            disabled={state === 'inactive' || disableAction}
          >
            {buttonText}
          </Button>
        </S.ActionContainer>
      ) : null}
    </S.Container>
  )
}

export default Step
